import React from 'react';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';

import Input, {InputAdornment, InputLabel} from 'material-ui/Input';
import { Select, TextField, withValidatedInputs, Validations } from '../../../../components/forms';
import {MenuItem} from 'material-ui/Menu';
import {FormHelperText, FormControl} from 'material-ui/Form';

import ExpansionPanel, {ExpansionPanelDetails, ExpansionPanelSummary,} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';

import Paper from 'material-ui/Paper';

import {Done, Close} from 'material-ui-icons';

import Grid from 'material-ui/Grid';

import tsl from './../../../tsl';
import Immutable from 'immutable';
import { getSettings } from 'utils/client';

class Editation extends React.Component {
    state = {
        entity: {},
        translations: {},
        activeLanguage: null,
        languages: ['en', 'de', 'fr', 'it'],
    };

    componentWillMount() {
        this.setEntity(this.props.entityData);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.entityData != this.props.entityData) {
            this.setEntity(newProps.entityData);
        }
    }

    setEntity(entityData) {
        //console.log('entity data', entityData);
        entityData = Immutable.fromJS(entityData).toJS();

        // phone and email are taken from client if empty, so we need to set them to the location's own value when editing
        entityData.phone = entityData.own_phone;
        entityData.email = entityData.own_email;

        let translations = [];
        for (let i in entityData.translations) {
            const tsl = entityData.translations[i];
            translations[tsl.locale] = tsl;
        }

        delete entityData.translations;

        this.setState({
            entity: entityData,
            translations: translations,
            activeLanguage: this.state.languages[0]
        })
    }

    handleChange = event => {
        let entity = this.state.entity;
        entity[event.target.name] = event.target.value;

        this.setState({entity: entity});
    }

    handleChangeLanguage = event => {
        this.setState({activeLanguage: event.target.value});
    }

    handleLngChange = event => {
        const prop = event.target.name;
        const actLng = this.state.activeLanguage;
        const value = event.target.value;

        let entityTsls = this.state.translations;
        if (!entityTsls[actLng]) {
            entityTsls[actLng] = {};
        }

        entityTsls[actLng][prop] = value;

        this.setState({translations: entityTsls});   
    }

    handleFilesChange = (files) => {
        let entity = this.state.entity;
        entity.files = files;
        this.setState({
            entity: entity
        });
    }

    handleSave = () => {
        if (this.props.trySubmit()) {
            let entity = this.state.entity;

            for (let lngCode in this.state.translations) {
                entity[lngCode] = this.state.translations[lngCode];
            }

            this.props.saveEntity(this.state.entity);
        }
    }

    handleDelete = () => {
        this.props.deleteEntity(this.state.entity);
    }

    handleClose = () => {
        // reset entity
        this.setEntity(this.props.entityData);

        this.props.onBackBtn();
        this.props.resetFormErrors();
    }

    togglePanel = () => {
        this.setState({
            panelIndex: (!this.state.panelIndex)
        })
    }

    renderEntityInformationForm() {
        let current_translation = this.state.translations[this.state.activeLanguage];
        if (!current_translation) {
            current_translation = { note: '' };
        }

        return (
            <Grid container spacing={24}>
                <Grid item xs={12} sm={12}>
                    <TextField
                        formActions={this.props.formActions}
                        required
                        fullWidth
                        id="name"
                        label={tsl('locations.editform.name')}
                        helperText={tsl('locations.editform.name_helper')}
                        name="name"
                        value={this.state.entity.name || ''}
                        onChange={this.handleChange}
                    />
                    <br />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isNumeric,
                            Validations.min(-90),
                            Validations.max(90),
                        ]}
                        fullWidth
                        id="gps_lat"
                        label={tsl('locations.editform.gps_lat')}
                        name="gps_lat"
                        value={this.state.entity.gps_lat || ''}
                        onChange={this.handleChange}
                    />
                    <br /><br />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isNumeric,
                            Validations.min(-180),
                            Validations.max(180),
                        ]}
                        fullWidth
                        id="gps_long"
                        label={tsl('locations.editform.gps_long')}
                        name="gps_long"
                        value={this.state.entity.gps_long || ''}
                        onChange={this.handleChange}
                    />
                    <br /><br />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        formActions={this.props.formActions}
                        fullWidth
                        id="phone"
                        label={tsl('locations.editform.phone')}
                        name="phone"
                        value={this.state.entity.phone || ''}
                        onChange={this.handleChange}
                        placeholder={getSettings('phone')}
                    />
                    <br /><br />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        formActions={this.props.formActions}
                        fullWidth
                        id="email"
                        label={tsl('locations.editform.email')}
                        name="email"
                        value={this.state.entity.email || ''}
                        onChange={this.handleChange}
                        placeholder={getSettings('email')}
                    />
                    <br /><br />
                </Grid>

                <Grid item xs={12} sm={3}>

                    <FormControl fullWidth>
                        <InputLabel htmlFor="language">{tsl('locations.editform.language_to_edit')}</InputLabel>
                        <Select
                            name="language"
                            value={this.state.activeLanguage ? this.state.activeLanguage : 0}
                            onChange={this.handleChangeLanguage}
                        >
                            <MenuItem value={0}>{'- '+tsl('locations.editform.select_one')+' -'}</MenuItem>
                            {this.state.languages.map((lang_code) => {
                                return (<MenuItem key={lang_code} value={lang_code}>{lang_code}</MenuItem>);
                            })}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={9}>

                    <TextField
                        fullWidth
                        label={tsl('locations.editform.note')}
                        helperText={tsl('locations.editform.note_helper')}
                        name="note"
                        value={current_translation.note || ''}
                        onChange={this.handleLngChange}
                        InputProps={{startAdornment: 
                            <InputAdornment position="start">{this.state.activeLanguage ? this.state.activeLanguage : '-'}</InputAdornment>}}
                    />

                </Grid>
            </Grid>
        );
    }

    render() {
        return (
            <div className="w-100">

                <Button fab raised color="accent"
                    className="jr-fab-btn text-white"
                    style={{position: "fixed", bottom: 5, right: 5, zIndex: 9999}}
                    onClick={() => {this.handleSave()}}
                >
                    <Done />
                </Button>

                <Button fab raised
                    className="jr-fab-btn jr-btn-fab-sm text-white"
                    style={{position: "fixed", bottom: 5, right: 70, zIndex: 9999}}
                    onClick={this.handleClose}
                >
                    <Close />
                </Button>

                <Paper style={{padding: 20}}>
                    {this.renderEntityInformationForm()}
                </Paper>

                {/* show delete section, only when entity is already saved (has ID) */}
                {!this.state.entity.id ? null : 
                    <div>
                        <br />

                        <ExpansionPanel expanded={this.state.panelIndex} onChange={this.togglePanel}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                                <Typography>{tsl('locations.edit.delete_panel')}</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails style={{color: "red"}}>

                                <h2>{tsl('locations.delete.confirmation')}</h2>
                                
                                <Button onClick={this.handleDelete}>{tsl('locations.delete.yes_btn')}</Button>
                            
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </div>
                }

            </div>
        );
    }
}

export default withValidatedInputs(Editation);


// WEBPACK FOOTER //
// ./app/used/locations/routes/Editation.js